import { render, staticRenderFns } from "./PreviewSidebar.vue?vue&type=template&id=5d07c117&scoped=true&"
import script from "./PreviewSidebar.vue?vue&type=script&lang=ts&"
export * from "./PreviewSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./PreviewSidebar.vue?vue&type=style&index=0&id=5d07c117&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d07c117",
  null
  
)

export default component.exports